// @view
import React from 'react'

export default React.forwardRef(function Canvas(props, ref) {
  let { isShown, width, height, zIndex, position, canvasRef } = props

  return (
    <canvas
      style={{
        display: isShown ? 'block' : 'none',
        zIndex: zIndex || 'auto',
        position: position || 'unset',
        width: typeof width === 'string' ? width : undefined,
        height: typeof height === 'string' ? height : undefined,
      }}
      width={typeof width === 'number' ? width : undefined}
      height={typeof height === 'number' ? height : undefined}
      ref={canvasRef || ref}
    />
  )
})
